import { FC, MutableRefObject, ReactElement, useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { EIconSize } from 'utils/constants/app/ui';
import { GlobalIcon } from 'components/GlobalIcon';
import { Option, Select } from 'newcomponents/UI/Select';
import { setGameStatus } from 'store/actions/results-data';
import { getResultsStatus } from 'store/selectors/results-data';
import './index.less';

type Props = {
  disabled?: boolean;
};

export const StatusFilter: FC<Props> = ({ disabled }): ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const resultsStatus = useSelector(getResultsStatus);
  const containerRef =
    useRef<HTMLDivElement>() as MutableRefObject<HTMLDivElement>;

  const handleChange = useCallback((value: 'live' | 'finished') => {
    dispatch(setGameStatus(value));
  }, []);

  return (
    <div className="statusFilter" ref={containerRef}>
      <div className="statusFilter__label">{t('sportsbook.status')}</div>
      <Select
        suffixIcon={
          <GlobalIcon
            lib="generic"
            name="selectArrow"
            theme="default"
            size={EIconSize._12}
          />
        }
        size="large"
        className="statusFilter__select"
        onChange={handleChange}
        defaultValue="finished"
        value={resultsStatus}
        disabled={disabled}
        getPopupContainer={() => containerRef.current}
      >
        <Option value="finished">{t('sportsbook.finished')}</Option>
        <Option value="live">{t('sportsbook.live')}</Option>
      </Select>
    </div>
  );
};
